<template>
  <el-card>
    <el-alert
      type="info"
      :closable="false"
      class="text-left"
    >
      If you cannot remember your OpenFreight password enter your email address and click the Send recovery link button below.
    </el-alert>

    <ForgotPasswordForm
      v-model="email"
      class="pt-3 pb-4"
    />

    <el-button
      type="primary"
      class="w-100"
      :loading="isRecoveringPassword"
      @click.native="initiatePasswordRecovery"
    >
      Send recovery link
    </el-button>

    <el-divider /><section>
      <el-link
        type="primary"
        @click.native="$router.push({ name: 'authentication-signin' })"
      >
        Return to sign in
      </el-link>

      <el-divider direction="vertical" />

      <el-link type="primary">
        Contact support
      </el-link>
    </section>
  </el-card>
</template>

<script>
import ForgotPasswordForm from '@/components/Authentication/ForgotPasswordForm'
import Request, { POST } from '@/plugins/sdk/Request'

export default {
  components: {
    ForgotPasswordForm
  },
  data () {
    return {
      isRecoveringPassword: false,
      email: ''
    }
  },
  created () {
    if (process.env.NODE_ENV === 'development') {
      this.email = process.env.VUE_APP_SIGNIN_EMAIL
    }
  },
  methods: {
    async initiatePasswordRecovery () {
      this.isRecoveringPassword = true

      const request = await (Object.assign(new Request(), {
        method: POST,
        _pathname: 'authenticate/forgot',
        body: {
          email: this.email
        }
      })).build()

      const response = await fetch(request)

      if (response.ok) {
        this.$message.success('A password recovery email has been sent')
        this.$router.push({ name: 'authentication-signin', query: { email: this.email } })
      }

      this.isRecoveringPassword = false
    }
  }
}
</script>
